import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
// import { RouterLink } from '@angular/router';
import { AffiliatesPageChangedEvent } from '../../components/affiliate-table/affiliate-table.component';
import { AffiliateTableComponent } from '../../components/affiliate-table/affiliate-table.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { PermissionService } from '@core/services/permission.service';
import { Permission } from '@shared/enums/permission.enum';
import { AffiliateListItemResponse } from '../../affiliate.model';
import { AffiliateStore } from '../../affiliate.store';
import { SHARED_IMPORTS } from '../../../../shared/modules/shared-imports.module';
import { SHARED_UTILS } from '@shared/modules/shared-utils.module';

@Component({
  selector: 'app-affiliate-list-page',
  imports: [ AffiliateTableComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './affiliate-list.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AffiliateListPage {
  protected readonly affiliateStore = inject(AffiliateStore);
  private readonly permissionService = inject(PermissionService);
  protected readonly actionAffiliateId = signal<string | null>(null);

  constructor() {
    this.affiliateStore.loadAffiliates();
  }

  readonly sharedUtils = SHARED_UTILS();

  protected canCreate(): boolean {
    return this.permissionService.hasPermission(Permission.AffiliatesCreate);
  }

  protected canUpdate(): boolean {
    return this.permissionService.hasPermission(Permission.AffiliatesUpdate);
  }

  protected canDeactivate(): boolean {
    return this.permissionService.hasPermission(Permission.AffiliatesDelete);
  }

  protected canActivate(): boolean {
    return this.permissionService.hasPermission(Permission.AffiliatesUpdate);
  }

  protected refresh(): void {
    this.affiliateStore.loadAffiliates();
  }

  protected searchAffiliates(search: string): void {
    this.affiliateStore.loadAffiliates(
      {
        pageNumber: 1,
        pageSize: this.affiliateStore.affiliatesPageSize(),
      },
      search,
    );
  }

  protected changePage(event: AffiliatesPageChangedEvent): void {
    this.affiliateStore.loadAffiliates({
      pageNumber: event.pageNumber,
      pageSize: event.pageSize,
    });
  }

  protected toggleAffiliateActive(affiliate: AffiliateListItemResponse): void {
    this.actionAffiliateId.set(affiliate.id);

    const complete = () => {
      this.affiliateStore.loadAffiliates();
      this.actionAffiliateId.set(null);
    };

    if (affiliate.isActive) {
      if (!this.canDeactivate()) {
        this.actionAffiliateId.set(null);
        return;
      }

      this.affiliateStore.deactivateAffiliate(affiliate.id, complete);
      return;
    }

    if (!this.canActivate()) {
      this.actionAffiliateId.set(null);
      return;
    }

    this.affiliateStore.activateAffiliate(affiliate.id, complete);
  }
}
